import { render, staticRenderFns } from "./CambioButacaPasoConfirmacion.vue?vue&type=template&id=589a2c44"
import script from "./CambioButacaPasoConfirmacion.vue?vue&type=script&setup=true&lang=js"
export * from "./CambioButacaPasoConfirmacion.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports